import React from "react";
import styled from "styled-components";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { isDesktop } from "../../utils/utils";
import PageHeader from "../PageHeader";

const CommonMobileHeader = ({ canBack, title, trailing }) => {
  const navigate = useNavigate();
  const onBack = () => {
    navigate(-1);
  };

  if (isDesktop) return <PageHeader title={title} trailing={trailing} />;

  return (
    <Wrapper>
      <div className="headerWrapper px-3 py-3 bg-white shadow-sm">
        {canBack && (
          <button type="button" className="bk-btn bg-transparent" onClick={onBack}>
            <IoMdArrowBack color="#000" size={23} />
          </button>
        )}
        <strong className="headerTitle text-dark text-center">{title}</strong>
        {trailing && <div className="trailing__item">{trailing}</div>}
      </div>
    </Wrapper>
  );
};

export default CommonMobileHeader;

const Wrapper = styled.div`
  margin-top: 5rem;
  .headerWrapper {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 5;
    height: 60px;
  }

  .bk-btn {
    position: absolute;
    left: 8;
    z-index: 10;
  }
  .headerTitle {
    position: absolute;
    margin: 0 auto;
    left: 0;
    right: 0;
  }

  .trailing__item {
    position: absolute;
    right: 16px;
    z-index: 10;
  }
`;
